import React, { useState, useMemo, useEffect } from 'react'
import BufferZonePage from './modules/BufferZonePage'
import settingService from '../../services/settingService'
import useSessionStorage from '../../hooks/useSessionStorage';
import { FiAlertTriangle, FiClock } from 'react-icons/fi';

const getSettingsFromResponse = (response) => {
  const responseData = response?.data?.data ?? response?.data;
  const settings = Array.isArray(responseData) ? responseData[0] : responseData;
  return settings && typeof settings === 'object' ? settings : {};
};

const BufferZone = () => {
  const [emergencyMode, setEmergencyMode] = useState(false);
  const { readSession } = useSessionStorage()
  const userDetails = useMemo(() => readSession('userDetails', null), [readSession])
  const companyId = userDetails?.companyId;

  useEffect(() => {
    if (!companyId) return;

    settingService.get('909').then((response) => {
      const settings = getSettingsFromResponse(response);
      setEmergencyMode(Boolean(settings.emergencyMode));
    }).catch((error) => {
      console.error('Error fetching settings:', error);
    });
  }, [companyId]);

  if(emergencyMode && companyId !== "909"){
    return (
      <div className="relative flex min-h-[calc(100vh-5rem)] w-full items-center justify-center overflow-hidden bg-customBackColor/60 px-4 py-12 dark:bg-custom_dark_background sm:px-6">
        <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
          <div className="absolute -left-24 -top-24 h-72 w-72 rounded-full bg-customOrange/10 blur-3xl" />
          <div className="absolute -bottom-28 -right-20 h-80 w-80 rounded-full bg-customAccentBlue/10 blur-3xl" />
        </div>

        <div className="relative w-full max-w-xl overflow-hidden rounded-3xl border border-customOrange/20 bg-white/95 p-6 text-center shadow-2xl shadow-customOrange/10 backdrop-blur dark:border-customSurfaceMuted dark:bg-customSurface/95 sm:p-10">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-customOrange/10 text-customOrange ring-8 ring-customOrange/5">
            <FiAlertTriangle size={30} aria-hidden="true" />
          </div>

          <div className="mt-7">
            <span className="inline-flex items-center gap-2 rounded-full border border-customOrange/20 bg-customOrange/5 px-3 py-1 text-xs font-bold uppercase tracking-wider text-customOrange">
              <span className="h-2 w-2 animate-pulse rounded-full bg-customOrange" />
              Temporarily unavailable
            </span>
            <h1 className="mt-4 text-2xl font-extrabold tracking-tight text-customInk dark:text-customHeading sm:text-3xl">
              Buffer Zone is currently paused
            </h1>
            <p className="mx-auto mt-3 max-w-md text-sm leading-6 text-customSecondaryText dark:text-customMuted sm:text-base">
              This workspace is temporarily unavailable while emergency mode is active. Your account and existing data are not affected.
            </p>
          </div>

          <div className="mt-7 flex items-center justify-center gap-2 rounded-2xl border border-customMuted/20 bg-customSlate/40 px-4 py-3 text-sm font-semibold text-customSecondaryText dark:border-customSurfaceMuted dark:bg-custom_dark_secondary/50 dark:text-customMuted">
            <FiClock className="shrink-0 text-customOrange" size={18} aria-hidden="true" />
            Please check back again later.
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-full flex-col gap-4 bg-customBackColor/60 dark:bg-custom_dark_background p-2 lg:p-4">
      <BufferZonePage
        emergencyMode={emergencyMode}
        //onToggleEmergencyMode={() => setEmergencyMode((previous) => !previous)}
      />
    </div>
  )
}

export default BufferZone

//lg:bg-gradient-to-br lg:from-customSlate lg:via-white lg:to-customSky
